"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Drop24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M2,11.1195972 C2,13.8104125 4.23411989,16 7,16 C9.76588011,16 12,13.8104125 12,11.1195972 C12,9.37736975 10.3749077,6.807732 7,3.41146763 C3.62509228,6.807732 2,9.37736975 2,11.1195972 Z M7,18 C3.13846311,18 0,14.9240954 0,11.1195972 C0,8.63912291 1.93463065,5.62563831 5.82021757,1.76279595 L7,0.589919463 L8.17978243,1.76279595 C12.0653694,5.62563831 14,8.63912291 14,11.1195972 C14,14.9240954 10.8615369,18 7,18 Z", id: `drop24-${id0}` })),
        react_1.default.createElement("g", { id: "drop-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { id: "Icons/Other/24", transform: "translate(5.000000, 3.000000)" },
                react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                    react_1.default.createElement("use", { xlinkHref: `#drop24-${id0}` })),
                react_1.default.createElement("use", { id: "Mask", fill: "#000000", fillRule: "nonzero", xlinkHref: `#drop24-${id0}` }))));
}
function Drop24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Drop24Svg, Object.assign({}, svgProps)));
}
exports.default = Drop24;
//# sourceMappingURL=Drop24.js.map